"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./DashboardGrid.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class DashboardGrid extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getStyle", () => {
      let _this$props = this.props,
          style = _this$props.style,
          cols = _this$props.cols,
          rows = _this$props.rows,
          gap = _this$props.gap,
          areas = _this$props.areas;
      return _extends({}, style, {
        display: "grid",
        gridGap: gap,
        gridTemplateColumns: cols,
        gridTemplateRows: rows,
        gridTemplateAreas: areas
      });
    });
  }

  render() {
    const style = this.getStyle();
    return _react.default.createElement("section", {
      className: "admin-dashboard__grid",
      style: style
    }, this.props.children);
  }

}

_defineProperty(DashboardGrid, "defaultProps", {
  style: {},
  gap: undefined,
  cols: undefined,
  rows: undefined,
  areas: undefined
});

var _default = DashboardGrid;
exports.default = _default;
module.exports = exports.default;